<div class="esign-wrap">
  <div class="wrap-lg">
    <iframe frameborder="0" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" #iframe></iframe>
  </div>
</div>
